/** Match the server's bcrypt limit before submitting a password. */
export function passwordValidationError(password: string): string | null {
  if (password.length < 12) return 'Use at least 12 characters.';
  if (new TextEncoder().encode(password).length > 72) return 'This password is too long. Shorten it or use fewer symbols.';
  return null;
}
